// removed by extract-text-webpack-plugin
module.exports = {"PopoverEmbed":"src-components-videos----popover-embed-module---PopoverEmbed---1MDsz","PopoverEmbed__btn":"src-components-videos----popover-embed-module---PopoverEmbed__btn---1NyvY","Popover_placeholder":"src-components-videos----popover-embed-module---Popover_placeholder---3KPRV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/videos/popover-embed.module.scss
// module id = 219
// module chunks = 35783957827783 169559349407212